import React from "react";
import StyleButton from "./StyleButton"

let BlockStyleControls = (props) => {
    let {editorState} = props
    let selection = editorState.getSelection ()
    let blockType = editorState
        .getCurrentContent ()
        .getBlockForKey (selection.getStartKey ())
        .getType ()

    return <span>
        { props.blockControls.map (el =>
            <StyleButton
                key={ el.label }
                active={ el.style === blockType }
                label={ el.label }
                onToggle={ props.onToggle }
                style={ el.style }
                icon={ el.icon }
            />
        ) }
    </span>
}

export default BlockStyleControls